import { withJsonFormsMultiEnumProps } from "@jsonforms/react";
import { Dropdown } from "pepsico-ds";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { GlobalConfigContext } from "../../../context/GlobalConfigContext";
import { useTranslatedCampaigns } from "../../../hooks/useTranslatedCampaigns";
import { getTranslatedText } from "../../../utils/commons";
import { getUpdatedCampaignConfiguration } from "../../campaign/campaignUtils";

const CampaignTypeSelectComponent = (props) => {
  const { t } = useTranslation();
  const { handleChange, label, path, required, uischema, visible, enabled, data } =
    props;

  const [selected, setSelected] = useState([]);
  const [hasLoadedData, setHasLoadedData] = useState(false);
  const { campaignsConfiguration, campaignGroups } = useContext(GlobalConfigContext);
  const campaignTypeLabelMap = useTranslatedCampaigns();

  const updatedCampaignConfiguration = getUpdatedCampaignConfiguration(
    campaignsConfiguration,
    campaignGroups
  );

  const campaignOptions = updatedCampaignConfiguration.map((campaign) => ({
    id: campaign.key,
    displayText: uischema.translated
      ? campaignTypeLabelMap[campaign.key] || ""
      : campaign.value?.label || campaign.name || campaign.key || "",
  }));

  // Handle initial data loading
  useEffect(() => {
    if (data && !hasLoadedData) {
      // Handle single selection mode with string type
      if (
        uischema.options?.multiple === false &&
        uischema.schema?.type === "string"
      ) {
        const selectedOption = campaignOptions.find((option) => option.id === data);
        setSelected(selectedOption ? [selectedOption] : []);
        setHasLoadedData(true);
        return;
      }

      // Handle multiple selection or single selection with array type
      const formattedData = uischema.returnStringFormat
        ? data.split(",").map((item) => item.trim())
        : data;

      const selectedOptions = campaignOptions.filter((option) =>
        formattedData.includes(option.id)
      );

      setSelected(selectedOptions);
      setHasLoadedData(true);
    }
  }, [
    data,
    hasLoadedData,
    campaignOptions,
    uischema?.returnStringFormat,
    uischema?.options?.multiple,
    uischema?.schema?.type,
  ]);

  const formatData = (data) => (data ? data.map((item) => item.id) : []);

  const handleSelectValue = (val) => {
    setSelected(val);

    // Handle single selection mode when schema type is string
    if (uischema.options?.multiple === false && uischema.schema?.type === "string") {
      const singleValue = val && val.length > 0 ? val[0].id : "";
      handleChange(path, singleValue);
      return;
    }

    // Handle multiple selection or single selection with array type
    const formattedData = uischema.returnStringFormat
      ? formatData(val).join(",")
      : formatData(val);

    handleChange(path, formattedData);
  };

  return visible ? (
    <div className="multiple-select-wrap">
      <Dropdown
        label={getTranslatedText(t, label, label)}
        childList={campaignOptions}
        selection={uischema.options?.multiple === false ? "single" : "multiple"}
        isRequired={required}
        disabled={!enabled}
        selectedValue={selected || undefined}
        placeholder={getTranslatedText(
          t,
          uischema.placeholder,
          uischema.placeholder
        )}
        setSelectedValue={handleSelectValue}
      />
    </div>
  ) : null;
};

export const CampaignTypeSelectControl = withJsonFormsMultiEnumProps(
  CampaignTypeSelectComponent
);
